import {action, observable} from "mobx";
import BaseStore from "./Base.store";

import {Dates, RemoveAcento} from "../utils";

import Api from "../config/api";
import {createMutation} from "../pages/Querys";

import Moment from "moment";
import {extendMoment} from "moment-range";
import string from "../utils/string";
import {getProfissionalSaudeLogado} from '../services/UsuarioService'

const moment = extendMoment(Moment);

const defaultSearchDTO = {
    pageNumber: 0,
    pageSize: 20,
    search: ""
};

export default class ConfiguracaoHorarioAtendimentoStore extends BaseStore {
    configDefault = null;

    filtroHeaderStore = null;

    @observable agendaValues = [];
    @observable configuracoes = [];

    @observable loadingConfig = true;
    @observable configErrorMessage = null;
    @observable duracaoError = false;

    @observable totalElements = 0;
    @observable numberOfElements = 0;
    @observable loading = true;
    @observable saving = false;
    @observable horarioAtendimentoList = [];
    @observable searchDTO = {
        ...defaultSearchDTO
    };
    @observable last = false;

    @observable values = {
        id: null,
        duracao: "",
        horaInicioPeriodoAtendimento: null,
        horaFimPeriodoAtendimento: null,
        dataInicioVigencia: null,
        dataFimVigencia: null,
        periodosAtendimento: [],
        horariosAtendimento:[]
    };

    @action
    unselectAll() {
        window.selectableGroup.clearSelection();
    }

    @action
    setDuracao(duracao) {
        this.values.duracao = parseInt(duracao) || 0;
        this.duracaoError = false;

        if (this.values.duracao >= 5) {
            this.unselectAll();
            this.setAgenda(this.values);
        } else {
            this.duracaoError = true;
        }
    }

    @action
    setAgendaValues(agendaValues) {
        this.agendaValues = agendaValues;
    }

    @action
    insertAgendaValues(item) {
        this.agendaValues.push(item);
    }

    @action setId(id) {
        this.values.id = id;
    }

    @action setDataInicioVigencia(dataInicioVigencia) {
        this.values.dataInicioVigencia = dataInicioVigencia;
    }

    @action setDataFimVigencia(dataFimVigencia) {
        this.values.dataFimVigencia = dataFimVigencia;
    }

    @action setHoraInicioPeriodoAtendimento(horaInicioPeriodoAtendimento = 0) {
        this.unselectAll();
        this.values.horaInicioPeriodoAtendimento = horaInicioPeriodoAtendimento;

        this.setAgenda(this.values);
    }

    @action setHoraFimPeriodoAtendimento(horaFimPeriodoAtendimento = 0) {
        this.unselectAll();
        this.values.horaFimPeriodoAtendimento = horaFimPeriodoAtendimento;

        this.setAgenda(this.values);
    }

    @action reset() {
        this.values = {
            id: null,
            duracao: "",
            horaInicioPeriodoAtendimento: null,
            horaFimPeriodoAtendimento: null,
            dataInicioVigencia: null,
            dataFimVigencia: null,
            periodosAtendimento: []
        };
    }

    @action resetSearchDTO() {
        this.searchDTO = {
            ...defaultSearchDTO
        };
        this.currentPage = null;
    }

    @action
    createAgenda() {
        this.agendaValues = [];
        this.reset();

        this.values = {
            ...this.configDefault,
            dataInicioVigencia: moment(),
            periodosAtendimento: []
        };
        const {
            duracao,
            horaInicioPeriodoAtendimento,
            horaFimPeriodoAtendimento
        } = this.values;

        let hoursDay = Dates.getMinutesOfInterval(
            horaInicioPeriodoAtendimento,
            horaFimPeriodoAtendimento,
            duracao
        );

        for (let x = 0; x < 7; x++) {
            let newArray = [];
            hoursDay.map(hour => newArray.push({ ...hour }));

            this.agendaValues.push({
                id: this.getNameWeekDay(moment().day(x)),
                name: moment()
                    .day(x)
                    .format("ddd"),
                values: newArray,
                isNew: true
            });
        }
    }

    @action
    setAgenda(configuracaoVigente) {
        this.agendaValues = [];

        this.values = configuracaoVigente;
        const {
            duracao,
            horaInicioPeriodoAtendimento,
            horaFimPeriodoAtendimento,
            periodosAtendimento
        } = this.values;

        const existsInPeriodos = (weekDay, hour) => {
            return periodosAtendimento.some(periodo => {
                const start = moment(
                    Dates.hourAndMinuteForString(periodo.horaInicio)
                );
                const end = moment(
                    Dates.hourAndMinuteForString(periodo.horaFim)
                );

                return (
                    weekDay === periodo.diaSemana &&
                    Dates.existInRange(start, end, hour.valueDate)
                );
            });
        };

        let hoursDay = Dates.getMinutesOfInterval(
            horaInicioPeriodoAtendimento,
            moment(horaFimPeriodoAtendimento).subtract(duracao, "minutes"),
            duracao
        );

        for (let x = 0; x < 7; x++) {
            let newArray = [];
            hoursDay.map(hour => newArray.push({ ...hour }));
            const weekDay = this.getNameWeekDay(moment().day(x));

            this.agendaValues.push({
                id: weekDay,
                name: moment()
                    .day(x)
                    .format("ddd"),
                values: newArray.map(hour => {
                    return {
                        ...hour,
                        selected: existsInPeriodos(weekDay, hour)
                    };
                }),
                isNew: true
            });
        }
    }

    @action
    createTimesSelecteds() {
        this.values.periodosAtendimento = [];

        let initializateDate = false;
        let previusDate = null;
        let periodo = {
            diaSemana: "",
            horaInicio: null,
            horaFim: null
        };

        this.agendaValues.forEach(weekDay => {
            weekDay.values.forEach(hour => {
                if (!initializateDate && hour.selected) {
                    periodo.horaInicio = hour.value;
                    periodo.diaSemana = weekDay.id;

                    previusDate = hour.value;
                    initializateDate = true;
                }

                if (hour.selected) {
                    previusDate = hour.value;
                }

                if (initializateDate && (!hour.selected || this.getUltimoHorario(previusDate, this.values.duracao, this.values.horaFimPeriodoAtendimento))) {
                    periodo.horaFim = previusDate;
                    this.values.periodosAtendimento.push(periodo);
                    initializateDate = false;

                    periodo = {
                        diaSemana: "",
                        horaInicio: null,
                        horaFim: null
                    };
                }
            });
    
            if (initializateDate) {
                periodo.horaFim = previusDate;
                this.values.periodosAtendimento.push(periodo);
            }
    
            initializateDate = false;
        });
    }

    @action
    async findAll(searchDTO = {}) {
        try {
            if (this.currentPage === this.searchDTO.pageNumber) {
                return;
            }

            this.currentPage = this.searchDTO.pageNumber;

            const {
                unidadeId,
                profissionalSaudeId
            } = await this.filtroHeaderStore.getFiltroAtual();

            const {
                showFiltroProfissionalSaude
            } = await this.filtroHeaderStore.checkRoles(
                "CONFIGURACAO_HORARIO_ATENDIMENTO"
            );

            if (profissionalSaudeId === 0 && showFiltroProfissionalSaude) {
                throw new Error(
                    "É necessário selecionar um profissional de saúde."
                );
            }

            const profissionalSaudeAtual = await getProfissionalSaudeLogado();
            let metodoFindAllConfiguracaoVigente = "findAllConfiguracaoHorarioAtendimento";
            if (profissionalSaudeAtual?.id !== profissionalSaudeId && showFiltroProfissionalSaude) {
                metodoFindAllConfiguracaoVigente = 'findAllConfiguracaoHorarioAtendimentoOutrosProfissionaisSaude';
            }

            this.searchDTO = {
                ...this.searchDTO,
                ...searchDTO
            };
            this.loading = true;

            const response = await Api.post("", {
                query: `
                query ($searchDTO: SearchDTOInput) {
                    findAllConfiguracaoHorarioAtendimento: ${metodoFindAllConfiguracaoVigente}(searchDTO: $searchDTO) {
                        numberOfElements
                        last
                        content {
                            id
                            dataInicioVigencia
                            dataFimVigencia
                            horaInicioPeriodoAtendimento
                            horaFimPeriodoAtendimento
                            duracao
                        }
                    }
                }
                      `,
                variables: {
                    searchDTO: {
                        ...this.searchDTO,
                        ...searchDTO,
                        unidadeId,
                        profissionalSaudeId,
                        sortField: "dataInicioVigencia",
                        sortDir: "DESC"
                    }
                }
            });

            const { content, last } = response.data.data.findAllConfiguracaoHorarioAtendimento;

            const list = content;
            this.numberOfElements =
                response.data.data.findAllConfiguracaoHorarioAtendimento.numberOfElements;
            this.last = last;

            if (
                this.numberOfElements === 0 &&
                string.isEmpty(this.searchDTO.search)
            ) {
                return;
            }

            if (this.searchDTO.pageNumber > 1) {
                this.horarioAtendimentoList = [...this.horarioAtendimentoList, ...list];
            } else {
                this.horarioAtendimentoList = [...list];
            }
            this.searchDTO.pageNumber += 1;
        } catch (error) {
            throw error;
        } finally {
            this.loading = false;
        }
    }

    @action
    async findAllConfiguracaoHorarioAtendimentoSala(searchDTO = {}) {
        try {
            if (this.currentPage === this.searchDTO.pageNumber) {
                return;
            }

            this.currentPage = this.searchDTO.pageNumber;

            const {
                unidadeId,
                salaId
            } = await this.filtroHeaderStore.getFiltroAtual();

            if (salaId === 0) {
                return
            }

            this.searchDTO = {
                ...this.searchDTO,
                ...searchDTO
            };
            this.loading = true;

            const response = await Api.post("", {
                query: `
                query ($searchDTO: SearchConfiguracaoHorarioAtendimentoDTOInput, $pageableDTO: PageableDTOInput) {
                    findAllConfiguracaoHorarioAtendimentoSala(searchDTO: $searchDTO, pageableDTO: $pageableDTO) {
                        last
                        numberOfElements
                        content {
                            id
                            dataInicioVigencia
                            dataFimVigencia
                            horaInicioPeriodoAtendimento
                            horaFimPeriodoAtendimento
                            duracao
                        }
                    }
                }
                      `,
                variables: {
                    searchDTO: {
                        ...this.searchDTO,
                        ...searchDTO,
                        unidadeId,
                        salaId
                    },
                    pageableDTO: {
                        sortField: "dataInicioVigencia",
                        sortDir: "ASC"
                    }
                }
            });

            const { content, last, numberOfElements } = response.data.data.findAllConfiguracaoHorarioAtendimentoSala;

            if(!content) {
                return
            }

            const list = content;
            this.numberOfElements = numberOfElements;
            this.last = last;

            if (
                this.numberOfElements === 0 &&
                string.isEmpty(this.searchDTO.search)
            ) {
                return;
            }

            if (this.searchDTO.pageNumber > 1) {
                this.horarioAtendimentoList = [...this.horarioAtendimentoList, ...list];
            } else {
                this.horarioAtendimentoList = [...list];
            }
            this.searchDTO.pageNumber += 1;
        } catch (error) {
            throw error;
        } finally {
            this.loading = false;
        }
    }

    @action
    async getConfigPadrao() {
        try {
            this.loadingConfig = true;
            this.configErrorMessage = null;
            this.agendaValues = [];

            const query = `
                query {
                    configuracaoHorarioAtendimentoPadrao {
                        dataInicioVigencia
                        duracao
                        dataFimVigencia
                    
                        rede {
                            nome
                        }
                    
                        horaInicioPeriodoAtendimento
                        horaFimPeriodoAtendimento
                        profissionalSaude{
                            nome
                        }
                    }
                }
            `;

            const response = await Api.post("", {
                query
            });

            const {
                configuracaoHorarioAtendimentoPadrao
            } = response.data.data;

            const transformResponse = {
                configuracaoHorarioAtendimentoPadrao: {
                    ...configuracaoHorarioAtendimentoPadrao,
                    horaInicioPeriodoAtendimento: moment(
                        Dates.hourAndMinuteForString(
                            configuracaoHorarioAtendimentoPadrao.horaInicioPeriodoAtendimento
                        )
                    ),
                    horaFimPeriodoAtendimento: moment(
                        Dates.hourAndMinuteForString(
                            configuracaoHorarioAtendimentoPadrao.horaFimPeriodoAtendimento
                        )
                    )
                },
            };

            this.configDefault = transformResponse.configuracaoHorarioAtendimentoPadrao;

            this.createAgenda();
        } catch (error) {
            this.configErrorMessage = error.message;
        } finally {
            this.loadingConfig = false;
        }
    }

    @action
    async getConfigById(id) {
        try {
            this.loadingConfig = true;
            this.configErrorMessage = null;
            this.agendaValues = [];

            const query = `
                query {
                    findByIdConfiguracaoHorarioAtendimento(id: ${id}) {
                        id
                        dataInicioVigencia
                        duracao
                        dataFimVigencia
                        periodosAtendimento {
                            id
                            diaSemana
                            horaInicio
                            horaFim
                        }
                        rede{
                            nome
                        }
                        horaInicioPeriodoAtendimento
                        horaFimPeriodoAtendimento
                        profissionalSaude{
                            nome
                        }
                        horariosAtendimento {
                            diaSemana
                            horaFim
                            horaInicio
                            procedimentos {
                                id
                                nome
                            }
                            permiteAgendamento
                            permiteAgendamentoOnline
                            solicitante {
                                id
                                nome
                            }
                        }
                    }
                }
            `;

            const response = await Api.post("", {
                query
            });

            const {
                findByIdConfiguracaoHorarioAtendimento,
            } = response.data.data;

            const configuracaoVigente = findByIdConfiguracaoHorarioAtendimento || null;

            const transformResponse = {
                configuracaoVigente: configuracaoVigente
                    ? {
                          ...configuracaoVigente,
                          horaInicioPeriodoAtendimento: moment(
                              Dates.hourAndMinuteForString(
                                  configuracaoVigente.horaInicioPeriodoAtendimento
                              )
                          ),
                          horaFimPeriodoAtendimento: moment(
                              Dates.hourAndMinuteForString(
                                  configuracaoVigente.horaFimPeriodoAtendimento
                              )
                          ),

                          dataInicioVigencia: moment(
                              configuracaoVigente.dataInicioVigencia
                          ),
                          dataFimVigencia: configuracaoVigente.dataFimVigencia
                              ? moment(configuracaoVigente.dataFimVigencia)
                              : null
                      }
                    : null,
            };

            if (transformResponse.configuracaoVigente) {
                this.setAgenda(transformResponse.configuracaoVigente);
            } else {
                throw new Error('Nenhuma configuração encontrada');
            }
        } catch (error) {
            this.configErrorMessage = error.message;
        } finally {
            this.loadingConfig = false;
        }
    }

    getNameWeekDay(day) {
        let name = day.format("dddd");
        name = RemoveAcento(name);
        name = name.replace("-", "_");

        return name.toUpperCase();
    }

    @action
    async savePeriodos(salas) {
        const isContaisDataInicio = this.configuracoes.some(config => {
            return (
                this.values.id !== config.id &&
                Dates.existInRange(
                    moment(config.dataInicioVigencia, "DD/MM/YYYY"),
                    moment(config.dataFimVigencia, "DD/MM/YYYY"),
                    this.values.dataInicioVigencia
                )
            );
        });

        if(moment(this.values.dataInicioVigencia).isAfter(moment(this.values.dataFimVigencia))) {
            throw new Error('A data início de vigência é maior que a data fim de vigência');
        }

        if (isContaisDataInicio)
            return this.openNotification(
                "Data Inicio de vigência inválida",
                "warning"
            );

        return this.requestSave(this.values.id ? "update" : "create", salas);
    }

    async requestSave(action, salas) {
        try {
            this.saving = true;
            const {
                unidadeId,
                profissionalSaudeId,
                salaId
            } = await this.filtroHeaderStore.getFiltroAtual();

            const {
                horaInicioPeriodoAtendimento,
                horaFimPeriodoAtendimento,
                dataInicioVigencia,
                dataFimVigencia
            } = this.values;
            
            let sala;
            let profissionalSaude;
            if (salas) {
                sala = {id: salaId}
            }

            if (!salas) {
                profissionalSaude = {id: profissionalSaudeId}
            }

            const values = {
                ...this.values,
                horaInicioPeriodoAtendimento: moment(
                    horaInicioPeriodoAtendimento
                ).format("HH:mm"),
                horaFimPeriodoAtendimento: moment(horaFimPeriodoAtendimento).format(
                    "HH:mm"
                ),
                dataInicioVigencia: moment(dataInicioVigencia).format("YYYY-MM-DD"),
                dataFimVigencia:
                    dataFimVigencia && dataFimVigencia !== ""
                        ? moment(dataFimVigencia).format("YYYY-MM-DD")
                        : null,

                unidade: {id: unidadeId},
                profissionalSaude,
                sala

            };

            let metodo = 'ConfiguracaoHorarioAtendimento'
            if (salas) {
                metodo = 'ConfiguracaoHorarioAtendimentoSala'
            }

            const response = await Api.post(
                "",
                JSON.stringify({
                    query: createMutation(
                        {
                            name: `${action}${metodo}`,
                            objType: "ConfiguracaoHorarioAtendimentoInput",
                            objName: "configuracaoHorarioAtendimento",
                            attrsReturn: "id"
                        },
                        "mutation"
                    ),
                    variables: { configuracaoHorarioAtendimento: values }
                })
            );

            if(response.data.errors){
                throw response.data.errors[0]
            }

            this.touched = false;

            return response;
        } catch (error) {
            throw error;
        } finally {
            this.saving = false;
        }
    }

    addCreatedPeriodo(periodo) {
        this.setId(periodo.id);
        this.configuracoes.push(periodo);
    }

    @action
    async findById(periodo) {
        try {
            const response = await Api.post(
                "",
                JSON.stringify({
                    query: createMutation(
                        {
                            name: `findByIdConfiguracaoHorarioAtendimento`,
                            objType: "Long",
                            objName: "id",
                            attrsReturn: `
                            dataFimVigencia
                            dataInicioVigencia
                            duracao
                            horaFimPeriodoAtendimento
                            horaInicioPeriodoAtendimento
                            id
                            
                            periodosAtendimento {
                                id
                                diaSemana
                                horaInicio
                                horaFim
                            }
                            
                            rede{
                                nome
                            }   
                            
                            unidade{
                                nome
                            }
                            
                            profissionalSaude{
                                nome
                            }
                            
                        `
                        },
                        "query"
                    ),
                    variables: { id: periodo.id }
                })
            );

            const {
                findByIdConfiguracaoHorarioAtendimento
            } = response.data.data;

            const transformResponse = {
                ...findByIdConfiguracaoHorarioAtendimento,

                horaInicioPeriodoAtendimento: moment(
                    Dates.hourAndMinuteForString(
                        findByIdConfiguracaoHorarioAtendimento.horaInicioPeriodoAtendimento
                    )
                ),
                horaFimPeriodoAtendimento: moment(
                    Dates.hourAndMinuteForString(
                        findByIdConfiguracaoHorarioAtendimento.horaFimPeriodoAtendimento
                    )
                ),

                dataInicioVigencia: moment(
                    findByIdConfiguracaoHorarioAtendimento.dataInicioVigencia
                ).format("YYYY-MM-DD"),
                dataFimVigencia: findByIdConfiguracaoHorarioAtendimento.dataFimVigencia
                    ? moment(
                          findByIdConfiguracaoHorarioAtendimento.dataFimVigencia
                      ).format("YYYY-MM-DD")
                    : null
            };

            this.setAgenda(transformResponse);
        } catch (error) {
            throw error;
        }
    }

    @action
    cancel() {
        this.touched = false;
        this.value = {
            id: null,
            duracao: "",
            horaInicioPeriodoAtendimento: null,
            horaFimPeriodoAtendimento: null,
            dataInicioVigencia: null,
            dataFimVigencia: null,
            periodosAtendimento: []
        };
        this.unselectAll();
    }

    getUltimoHorario(horaAtual, duracao, horaFimPeriodoAtendimento) {
        return moment(horaAtual, "HH:mm").add(duracao, 'minutes').format("HH:mm") === horaFimPeriodoAtendimento.format("HH:mm");
    }
}
